export default "__VITE_ASSET__DTFczYFL__"